import {
    VISIT1_THERAPY_IS_EDITED,
    VISIT1_THERAPY_IS_ERROR,
    VISIT1_THERAPY_IS_GET,
    VISIT1_THERAPY_IS_LOADING
} from '../../actions/visit1/visit1TherapyAction';

const initialValues = {
    isLoading: false,
    isError: false,
    initialData: null,
    formData: null
};

export function visit1TherapyReducer(state = initialValues, action) {
    switch (action.type) {
        case VISIT1_THERAPY_IS_LOADING:
            return {...state, isLoading: true, isError: false};
        case VISIT1_THERAPY_IS_ERROR:
            return {...state, isLoading: false, isError: true};
        case VISIT1_THERAPY_IS_GET:
            return {...state, isLoading: false, isError: false, initialData: action.payload};
        case VISIT1_THERAPY_IS_EDITED:
            return {...state, isLoading: false, isError: false, formData: action.payload};
        default:
            return state;
    }
}
